/**
 * Slack and Linear senders are linked to a Rivets account by email only when
 * that account's email is verified (an unverified account could claim any
 * address). Members who never verified — including everyone who signed up
 * before verification existed — are therefore asked to confirm each link
 * instead, and are told why, here and on the link confirmation.
 */
/** The same sentence as native `IntegrationLinkingCopy.verifyEmailNote`. */
export function autoLinkVerificationText(): string {
  return "Verify your email address to let Rivets link your Slack and Linear accounts automatically. "
    + "Until then, you'll be asked to confirm each link.";
}

export function AutoLinkVerificationNote({ verified }: { verified: boolean | undefined }) {
  if (verified !== false) return null;
  return (
    <div className="alert alert-warning" role="status" data-testid="auto-link-verification-note">
      <span>
        {autoLinkVerificationText()} <a href="#account">Verify email</a>
      </span>
    </div>
  );
}
